export default __webpack_public_path__ + "static/media/book_activity.99191408.svg";